import { useState, useCallback, useEffect } from 'react'

export default function useCopyToClipboard(resetInterval = 2000) {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = useCallback((elementId) => {
    const text = document.getElementById(elementId).value
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true)
    }).catch((err) => {
      console.error('Failed to copy text using Clipboard API: ', err)
      setIsCopied(false)
    })
  }, [])

  useEffect(() => {
    if (isCopied) {
      const resetCopied = setTimeout(() => setIsCopied(false), resetInterval)
      return () => clearTimeout(resetCopied)
    }
  }, [isCopied, resetInterval])

  return { isCopied, handleCopy }
}
